module.exports = __webpack_public_path__ + "media/images/bnr-kit-sm-0858f68ddc582f9d895b4455dd8864dc.png";